// CSS
import './scss/main.scss';

// JS
import './js/index.js';
import 'bootstrap';

// IMAGES
import './images/border.png';
import './images/test.png';
import './images/NavChevron.svg';

import './images/brochures/bullet-paw.png';
import './images/brochures/bullet.png';
import './images/brochures/icon-address.png';
import './images/brochures/icon-cross.png';
import './images/brochures/icon-email.png';
import './images/brochures/icon-link.png';
import './images/brochures/icon-phone.png';
import './images/brochures/icon-tick.png';

// Fonts

import './fonts/6xKodSZaM9iE8KbpRA_p2HcYT8L5.woff';
import './fonts/6xKodSZaM9iE8KbpRA_pgHYYT8L5.woff';
import './fonts/6xKodSZaM9iE8KbpRA_pkHEYT8L5.woff';
import './fonts/6xKtdSZaM9iE8KbpRA_hK1QL.woff';
import './fonts/6xKodSZaM9iE8KbpRA_p2HcYT8L.woff2';
import './fonts/6xKodSZaM9iE8KbpRA_pgHYYT8L.woff2';
import './fonts/6xKodSZaM9iE8KbpRA_pkHEYT8L.woff2';
import './fonts/6xKtdSZaM9iE8KbpRA_hK1QN.woff2';



